import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Ghost, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function HalloweenBanner() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    api.get("/products/collections/halloween?limit=1").then((r) => setCount(r.data.total || 0)).catch(() => setCount(0));
  }, []);

  if (!count) return null;

  return (
    <section className="bg-[#120B1E] border-y-2 border-[#FF7A00]" data-testid="halloween-banner">
      <Link
        to="/halloween"
        className="max-w-[1400px] mx-auto px-6 md:px-8 py-4 flex items-center justify-between gap-3 group"
        data-testid="halloween-banner-link"
      >
        <div className="flex items-center gap-3 min-w-0">
          <Ghost className="w-7 h-7 text-[#FF7A00] shrink-0" />
          <div className="min-w-0">
            <div className="font-display font-black text-white text-lg md:text-xl tracking-tight leading-tight truncate">
              The Halloween Shop is <span className="text-[#FF7A00]">open</span>
            </div>
            <div className="text-white/60 text-xs md:text-sm truncate">
              {count} costumes, decorations & spooky props at closeout prices
            </div>
          </div>
        </div>
        <span className="shrink-0 inline-flex items-center gap-1.5 bg-[#FF7A00] text-[#120B1E] font-black text-xs md:text-sm px-4 py-2 rounded-full group-hover:bg-white transition-colors">
          Shop Halloween <ArrowRight className="w-4 h-4" />
        </span>
      </Link>
    </section>
  );
}
